module.exports = __webpack_public_path__ + "img/menu_btn.18392c58.png";